import Properties from "../../_model/ModelEngineeringProperties";
import { SingletonEnginnering } from "../singletonEngineering"

// Lógica Fábrica Destilaria
const i_1_500 = "cr|i_1_500|Atributos|W"
const i_5_100 = "cr|i_5_100|Atributos|W"
const w_5_22_P = "cr|5_22_P|Atributos|W"
const i_1_300 = "cr|i_1_300|Atributos|W"
const i_1_400 = "cr|i_1_400|Atributos|W"
const i_1_600 = "cr|i_1_600|Atributos|W"
const wvol_7_10_P = "cr|7_10_P|Atributos|WVol"
const brix_7_10_P = "cp|7_10_P|Caldo|brix"
const JTK_701_P = "op|AjusteCaldo|JTK_701_P|Saida"
const JTT_701_P = "op|AjusteCaldo2|JTT_701_P|Saida"
const JTT_701_P_WSaida = "op|AjusteCaldo2|JTT_701_P|WSaida"

const InputSeletora = () => {
  let n = SingletonEnginnering.getPropertieByToken(i_1_500)
  return n ? n : new Properties()
}
const InputMelFinal = () => SingletonEnginnering.getPropertieByToken(i_5_100)
const OutputMelFinal = () => SingletonEnginnering.getPropertieByToken(w_5_22_P) 
const InputLogicDestilaria = () => SingletonEnginnering.getPropertieByToken(i_1_400) 
const InputLogicFabrica = () => SingletonEnginnering.getPropertieByToken(i_1_300) 
const InputCaldoMisto = () => SingletonEnginnering.getPropertieByToken(i_1_600) 
const OutputMosto = () => SingletonEnginnering.getPropertieByToken(wvol_7_10_P) 
const OutputBrixMosto = () => SingletonEnginnering.getPropertieByToken(brix_7_10_P) 
const InputAjustCaldoBrixFab = () => SingletonEnginnering.getPropertieByToken(JTK_701_P)
const InputAjustCaldoBrixDest = () => SingletonEnginnering.getPropertieByToken(JTT_701_P) 
const InputAjustCaldoVazaoDest = () => SingletonEnginnering.getPropertieByToken(JTT_701_P_WSaida) 
const OutputVazaoDest = () => getCurrentByMisturador("Misturador|M_108_P", "WVol") 
const OutputVazaoFab = () => getCurrentByMisturador("Misturador|M_107_P", "WVol")


export {

  InputSeletora,
  InputMelFinal,
  OutputMelFinal,
  InputLogicDestilaria,
  InputLogicFabrica,
  InputCaldoMisto,
  OutputMosto,
  InputAjustCaldoBrixFab,
  InputAjustCaldoBrixDest,
  InputAjustCaldoVazaoDest,
  OutputVazaoFab,
  OutputVazaoDest,
  OutputBrixMosto
}

let getCurrentByMisturador = (index, key) => {
  try{  
    let prop =  SingletonEnginnering.getCurrentByMisturador(index, { index : 0, name: "Atributos"}).find(c => c.key == key)
    if(!prop) prop = new Properties();
    return prop
  }
  catch (e)
  {
    console.warn(`Falha ao coletar as correntes padrões Erro: ${e}`);
  }
}